export const deliveryMethodsTabs = {
  deliveryMethods: 'deliveryMethods',
  availabilityCriteria: 'availabilityCriteria',
}

export const deliveryMethodsTabList = [
  { label: 'Métodos de devolución', value: deliveryMethodsTabs.deliveryMethods },
  { label: 'Criterios de disponibilidad', value: deliveryMethodsTabs.availabilityCriteria },
]
